namespace RioERP.Reports {
    export interface B2BForm {
        InvoiceDate: Serenity.DateEditor;
        Invoicenumber: Serenity.StringEditor;
        EPaymentType: Serenity.IntegerEditor;
        CustomerName: Serenity.StringEditor;
        StateName: Serenity.StringEditor;
        Quantity: Serenity.IntegerEditor;
        SpecificationName: Serenity.StringEditor;
        Views: Serenity.IntegerEditor;
        Validity: Serenity.IntegerEditor;
        HsnCode: Serenity.StringEditor;
        TaxCategoryName: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        TaxableAmount: Serenity.DecimalEditor;
        CgstAmount: Serenity.DecimalEditor;
        SgstAmount: Serenity.DecimalEditor;
        IgstAmount: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        OrderNumber: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        City: Serenity.StringEditor;
        FranchiseeId: Serenity.IntegerEditor;
        Gstin: Serenity.StringEditor;
        OrderDate: Serenity.DateEditor;
    }

    export class B2BForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.B2B';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!B2BForm.init)  {
                B2BForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;

                Q.initFormType(B2BForm, [
                    'InvoiceDate', w0,
                    'Invoicenumber', w1,
                    'EPaymentType', w2,
                    'CustomerName', w1,
                    'StateName', w1,
                    'Quantity', w2,
                    'SpecificationName', w1,
                    'Views', w2,
                    'Validity', w2,
                    'HsnCode', w1,
                    'TaxCategoryName', w1,
                    'ProductName', w1,
                    'TaxableAmount', w3,
                    'CgstAmount', w3,
                    'SgstAmount', w3,
                    'IgstAmount', w3,
                    'NetAmount', w3,
                    'OrderNumber', w1,
                    'FranchiseeDiscountAmount', w3,
                    'City', w1,
                    'FranchiseeId', w2,
                    'Gstin', w1,
                    'OrderDate', w0
                ]);
            }
        }
    }
}
